const navLinks = [
    { href: "#skills", label: "Skills" },
    { href: "#experience", label: "Experience" },
    { href: "#projects", label: "Projects" },
    { href: "#education", label: "Education" },
    { href: "#contact", label: "Contact" },
];

function Navbar() {
    return (
        <nav className="navbar navbar-expand-lg site-navbar fixed-top px-4 py-3">
            <a className="navbar-brand" href="#home">Aanish Amir Waseem</a>
            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <div className="navbar-nav ms-auto px-2 mb-2 mb-lg-0">
                    {navLinks.map((link) => (
                        <a key={link.href} className="nav-item nav-link" href={link.href}>
                            {link.label}
                        </a>
                    ))}
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
